module.exports = __webpack_public_path__ + "static/media/creativeshead2.9809b0fe.jpg";